import React, { useRef, useState } from 'react';
import {useSurveyContext} from "../../../context/SurveyContext";
import moment from 'moment';
import DatePicker from 'react-datepicker';
import {convertDMYToDateObject, dateObjectToDMY, enGBFnsLocale} from "../../../utils/dateTimeUtils";
import { isInAllowedKeys } from '../../../utils/miscUtils';
import DateOnlyInput from '../../DateOnlyInput';

function DateQuestion(props) {

    const [open, setOpen] = useState(false);

    const inputRef = useRef();

    const {survey: {answers, passenger}, setAnswer} = useSurveyContext();
    const answer = answers[props.question.id] || "";

    const isShown = props.question.part === props.activePart;
    const elementId = `date-${props.question.id}`;

    const minDate = getDateObject(props.question.minDate, passenger);
    const maxDate = getDateObject(props.question.maxDate, passenger);

    return (
        <div className={isShown ? "w-full sm:w-1/2 xl:w-1/3" : "hidden"}>
            <label htmlFor={elementId} className="input-label">
                {props.question.questionText}
            </label>

            <DatePicker
                dateFormat="dd/MM/yyyy"
                selected={answer ? convertDMYToDateObject(answer) : null}
                placeholderText="DD/MM/YYYY"
                className="input-field text-black mt-1"
                onChange={(date) => {
                    setAnswer(props.question.id, dateObjectToDMY(date) || "");
                    inputRef.current.focus();
                    setOpen(false);
                }}
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                minDate={minDate}
                maxDate={maxDate}
                locale={enGBFnsLocale}
                onKeyDown={(e)=>{
                    if(!isInAllowedKeys(e.key)) e.preventDefault();
                }}
                customInput={<DateOnlyInput inputRef={inputRef} openOnFocus={() => setOpen(true)} />}
                open={open}
                onClickOutside={()=> setOpen(false)}
                popperPlacement="bottom-start"
            />
        </div>
    );
}

export default DateQuestion;

// This function is currently a convoluted way of converting date operations using moment,
// then formatting that to string and parsing it again to make a date object
// if used anywhere else, ever it shoudl be refactored to use the new date functions or another library
// that supports the same operations
function getDateObject(param, passenger) {
    if(!param) {
        return null;
    }

    // strings get parsed as ddmmyyyy format
    if(typeof param === "string") {
        return convertDMYToDateObject(param);
    }

    //add to todays date
    if(param.operation === "add") {
        return convertDMYToDateObject(moment().add(moment.duration(param.amount)).format("DD/MM/YYYY"));
    }

    //remove from todays date
    if(param.operation === "subtract") {
        return convertDMYToDateObject(moment().subtract(moment.duration(param.amount)).format("DD/MM/YYYY"));
    }

    if(param.operation === "referencePassengerField") {
        return convertDMYToDateObject(moment(passenger[param.field], "YYYY-MM-DD").format("DD/MM/YYYY"));
    }

    return null;
}
